import { AxiosError } from 'axios';
import api, { twUrl } from '../../utils/api';
import { QBOResponse } from './QBO.model';
import { UserResponse } from '../User/User.model';

export interface QBOSignInParams {
  divisionId: string;
}

export interface QBOSignOutParams {
  divisionId: string;
}

class QBOService {
  /**
   * Signs in QBO
   */
  static async signIn(divisionId?: string): Promise<QBOResponse> {
    try {
      const params: QBOSignInParams = {
        divisionId: divisionId || ''
      };
      const request = await api.post(twUrl.quickbooksAuth, divisionId ? params : undefined);
      return await request.data;
    } catch (error) {
      const err = error as AxiosError<any>;
      return err.response?.data;
    }
  }

  /**
   * Sends QBO credentials to the server
   */
  static async callback(query: string): Promise<UserResponse> {
    const request = await api.post(`${twUrl.quickbooksCallback}${query}`);
    return request.data.data;
  }

  static async signOut(divisionId?: string): Promise<string> {
    try {
      const params: QBOSignOutParams = {
        divisionId: divisionId || ''
      };
      const request = await api.post(twUrl.quickbooksSignOut, divisionId ? params : undefined);
      return await request.data.message;
    } catch (error) {
      const err = error as AxiosError<any>;
      return err.response?.data;
    }
  }
}

export default QBOService;
